import React, { Dispatch, useRef, MutableRefObject, useContext } from "react";
import { Trans } from "@lingui/macro";
import { WorkContext, Action } from "../WorkContext";
import { navigate } from "../../../utils";
import { styled, media, fonts, black, pink, white } from "../../../styles";
import { ProjectCategoryInterface } from "../../ProjectPage";
import { useWidth } from "../../../hooks";
import { useEffect } from "react";
import { useState } from "react";

export interface ProjectCategoriesProps {
  categories: ProjectCategoryInterface[];
  selectedCategory?: string;
  searchTerm?: string;
  searchOpen: boolean;
}

export const ProjectCategories: React.FC<ProjectCategoriesProps> = ({
  categories,
  selectedCategory,
  searchTerm,
  searchOpen
}) => {
  const containerRef = useRef<HTMLDivElement>();
  const { dispatch, state } = useContext(WorkContext);
  const pageX = useWidth();

  // console.log(state);

  useEffect(() => {
    if (
      containerRef.current &&
      "" === selectedCategory?.toString() &&
      pageX <= 1024
    ) {
      containerRef.current.focus();
    }
  }, [containerRef, pageX, selectedCategory]);

  const isMobile = pageX < 475;

  return (
    // @ts-ignore
    <ProjectCategoriesContainer tabIndex={1} ref={containerRef}>
      {/* <ProjectCategory
        to="/work/"
        checked={Boolean(
          (isMobile && searchOpen) || searchTerm || !selectedCategory
        )}
        slug="all"
        selectRef={containerRef}
        dispatch={dispatch}
      >
        <Trans>All</Trans>
      </ProjectCategory> */}

      {categories.map(category => (
        <ProjectCategory
          selectRef={containerRef}
          to={`/work/${category.slug}/`}
          key={category.slug}
          checked={
            !(isMobile && searchOpen) &&
            !searchTerm &&
            selectedCategory === category.slug
          }
          slug={category.slug}
          searchTerm={searchTerm}
          dispatch={dispatch}
        >
          {category.name}
        </ProjectCategory>
      ))}
    </ProjectCategoriesContainer>
  );
};

interface ProjectCategoryProps {
  slug: string;
  to: string;
  checked: boolean;
  selectRef?: MutableRefObject<HTMLDivElement | undefined>;
  searchTerm?: string;
  dispatch: Dispatch<Action>;
}

const ProjectCategory: React.FC<ProjectCategoryProps> = ({
  children,
  slug,
  to,
  selectRef,
  searchTerm,
  dispatch,
  checked = false
}) => (
  <>
    <input
      name="category"
      type="radio"
      id={slug}
      checked={checked}
      // disabled={typeof searchTerm === "string" && searchTerm.length > 0}
      onChange={e => {
        e.preventDefault();

        if (typeof searchTerm === "string" && searchTerm.length > 0) {
          dispatch({
            type: "SET_SEARCHTERM",
            searchTerm: ""
          });
        }

        if (selectRef && selectRef.current) {
          selectRef.current.blur();
        }

        navigate(to);
      }}
    />
    <label htmlFor={slug}>
      <span>{children}</span>
    </label>
  </>
);

const ProjectCategoriesContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 30px;
  overflow: visible;
  cursor: pointer;
  outline: none;

  ${media.tablet} {
    max-width: unset;
  }

  @media (min-width: 1251px) {
    flex-direction: row;
    margin-right: 6px;
  }

  label {
    display: flex;
    align-items: center;

    min-height: 30px;
    z-index: 1;
    box-sizing: border-box;
    overflow: hidden;
    white-space: nowrap;
    position: absolute;
    top: 0;
    width: 100%;
    margin-right: 0;
    color: ${white};
    text-align: left;
    order: 2;
    pointer-events: none;
    font-family: ${fonts.vario};
    text-transform: uppercase;
    margin-top: 2px;

    span {
      cursor: pointer;
      user-select: none;
      min-height: 30px;
      align-items: center;

      &:hover {
        animation: wahnsinn 0.3s linear 0s infinite;
      }
    }

    @media (max-width: 1250px) {
      span {
        background-color: ${black};
        padding: 0 0.5rem 0 0.5rem;
        font-size: 13px;
        display: flex;
      }

      &:hover {
        span {
          background-color: ${pink};
        }
      }
    }

    @media (min-width: 1251px) {
      position: relative;
      top: auto;
      width: auto;
      margin-right: 2px;
      text-align: center;
      order: initial;
      pointer-events: auto;

      span {
        font-size: 16px;
        background: transparent;
        color: ${black};
        padding: 0.4rem 0.9rem 0.5rem;
      }
    }
  }

  &:focus label {
    @media (max-width: 1250px) {
      position: relative;
      pointer-events: all;
    }
  }

  input {
    opacity: 0;
    position: absolute;
    left: -99999px;

    &:disabled + label {
      span {
        opacity: 0.7;
        cursor: not-allowed;
      }
    }

    &:checked + label {
      order: 1;
      z-index: 2;
      border-top: none;
      position: relative;

      @media (max-width: 1250px) {
        span {
          &:after {
            content: ">";
            padding-left: 10px;
          }
        }
      }

      @media (min-width: 1251px) {
        order: initial;

        span {
          background: ${black};
          color: ${white};
        }
      }
    }
  }
`;
